"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../types");
const base_wallet_subprovider_1 = require("./base_wallet_subprovider");
class WanWalletSubprovider extends base_wallet_subprovider_1.BaseWalletSubprovider {
    constructor() {
        super();
    }
    getAccountsAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                if (!this.isSupported()) {
                    reject(new Error(types_1.WalletSubproviderErrors.MethodNotSupported));
                }
                window.web3.eth.getAccounts((err, res) => {
                    if (err) {
                        reject(err);
                    }
                    else {
                        resolve(res);
                    }
                });
            }));
        });
    }
    signTransactionAsync(txData) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                if (!this.isSupported()) {
                    reject(new Error(types_1.WalletSubproviderErrors.MethodNotSupported));
                }
                window.web3.eth.signTx(txData, (err, res) => {
                    if (err) {
                        reject(err);
                    }
                    else {
                        resolve(res);
                    }
                });
            }));
        });
    }
    signPersonalMessageAsync(data, address) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                if (!this.isSupported()) {
                    reject(new Error(types_1.WalletSubproviderErrors.MethodNotSupported));
                }
                window.web3.eth.sign(data, address, (err, res) => {
                    if (err) {
                        reject(err);
                    }
                    else {
                        resolve(res);
                    }
                });
            }));
        });
    }
    signTypedDataAsync(address, typedData) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error(types_1.WalletSubproviderErrors.MethodNotSupported);
        });
    }
    isSupported() {
        if (!!window.web3 && !!window.web3.eth && !!window.injectWeb3) {
            return true;
        }
        else {
            return false;
        }
    }
}
exports.WanWalletSubprovider = WanWalletSubprovider;
//# sourceMappingURL=wanwallet.js.map